<rask-container-block>
  <div class="row">
    <rask-hot-doc
      [hotDoc]="hotDoc">
    </rask-hot-doc>
  </div>
  <br />
  @if (!viewModel.isMassEditering) {
    <div class="btn-group">
      <button type="button" aid="kapkriteria-forbjudet-att-kapa" [disabled]="!viewModel.canEdit" color="primary"
        class="btn kapkriteria-forbjudet-att-kapa" (click)="setKapkriterie('Förbjudet att kapa')">Förbjudet att
      kapa</button>
      <button type="button" aid="kapkriteria-endast-manuella-kap" [disabled]="!viewModel.canEdit" color="primary"
        class="btn kapkriteria-endast-manuella-kap" (click)="setKapkriterie('Endast manuella kap')">Endast manuella
      kap</button>
      <button type="button" aid="kapkriteria-endast-vardeaptering" [disabled]="!viewModel.canEdit" color="primary"
        class="btn kapkriteria-endast-vardeaptering" (click)="setKapkriterie('Endast värdeaptering')">Endast
      värdeaptering</button>
      <button type="button" aid="kapkriteria-inga-begransningar" [disabled]="!viewModel.canEdit" color="primary"
        class="btn kapkriteria-inga-begransningar" (click)="setKapkriterie('Inga begränsningar')">Inga
      begränsningar</button>
    </div>
  }
</rask-container-block>
